<template>
  <div class="order-manage-page">
    <div class="station-bar" @click="showStationPopup = true">
      <div class="station-info">
        <span>{{ currentStationName || '全部场站' }}</span>
        <i class="el-icon-sort rotate-90"></i>
      </div>
    </div>

    <div class="quick-filter">
      <div class="dropdown-item" @click="showFilterDrawer = true">
        {{ timeFilterLabel }} <i class="el-icon-caret-bottom"></i>
      </div>
      <div class="dropdown-item" @click="showFilterDrawer = true">
        {{ getSourceLabel(filterSource) }} <i class="el-icon-caret-bottom"></i>
      </div>
      <div class="dropdown-item" @click="showFilterDrawer = true">
        {{ getStatusLabel(filterStatus) }} <i class="el-icon-caret-bottom"></i>
      </div>
      <div class="filter-btn" @click="showFilterDrawer = true">
        <i class="el-icon-set-up"></i> 筛选
      </div>
    </div>

    <div class="summary-bar">
      <span>订单量(笔):</span>
      <span class="count">{{ totalCount }}</span>
    </div>

    <div class="order-list" v-loading="loading">
      <div class="order-card" v-for="(item, index) in orderList" :key="index" @click="goDetail(item)">
        <div class="card-header">
          <span class="time">创建时间：{{ item.createTime }}</span>
          <i class="el-icon-arrow-right"></i>
        </div>
        <div class="card-content">
          <div class="info-row">
            <span class="label">订单状态</span>
            <span class="status-tag" :class="getStatusClass(item.orderstate)">{{ getStatusLabel(item.orderstate) }}</span>
          </div>
          <div class="info-row">
            <span class="label">订单来源</span>
            <span class="val">{{ getSourceLabel(item.orderSource) }}</span>
          </div>
          <div class="info-row">
            <span class="label">订单总额(元)</span>
            <span class="val bold">{{ item.ordergold || item.price || '0' }}</span>
          </div>
          <div class="info-row">
            <span class="label">充电量(度)</span>
            <span class="val bold">{{ item.consumePower || '0' }}</span>
          </div>
        </div>
      </div>
      <div class="empty-holder" v-if="!loading && orderList.length === 0">
        <i class="el-icon-s-order"></i>
        <p>暂无订单数据</p>
      </div>
    </div>

    <div class="filter-mask" v-if="showFilterDrawer" @click.self="showFilterDrawer = false">
      <div class="filter-drawer">
        <div class="drawer-header">
          <span>筛选</span>
          <i class="el-icon-close" @click="showFilterDrawer = false"></i>
        </div>
        <div class="drawer-body">
          <section class="filter-section">
            <p class="section-title">创建时间</p>
            <div class="tag-grid">
              <span class="tag" :class="{active: filterTime === 'today'}" @click="filterTime = 'today'">今日</span>
              <span class="tag" :class="{active: filterTime === 'yesterday'}" @click="filterTime = 'yesterday'">昨日</span>
              <span class="tag" :class="{active: filterTime === 'month'}" @click="filterTime = 'month'">近一月</span>
              <span class="tag" :class="{active: filterTime === 'threeMonth'}" @click="filterTime = 'threeMonth'">近三月</span>
            </div>
          </section>

          <section class="filter-section">
            <p class="section-title">订单来源</p>
            <div class="tag-grid">
              <span class="tag" :class="{active: filterSource === ''}" @click="filterSource = ''">全部</span>
              <span class="tag" :class="{active: filterSource === '1'}" @click="filterSource = '1'">微信小程序</span>
              <span class="tag" :class="{active: filterSource === '2'}" @click="filterSource = '2'">H5</span>
              <span class="tag" :class="{active: filterSource === '3'}" @click="filterSource = '3'">卡</span>
              <span class="tag" :class="{active: filterSource === '4'}" @click="filterSource = '4'">互联互通</span>
            </div>
          </section>

          <section class="filter-section">
            <p class="section-title">订单状态</p>
            <div class="tag-grid">
              <span class="tag" :class="{active: filterStatus === ''}" @click="filterStatus = ''">全部</span>
              <span class="tag" :class="{active: filterStatus === '1'}" @click="filterStatus = '1'">下单</span>
              <span class="tag" :class="{active: filterStatus === '2'}" @click="filterStatus = '2'">取消</span>
              <span class="tag" :class="{active: filterStatus === '3'}" @click="filterStatus = '3'">支付成功</span>
              <span class="tag" :class="{active: filterStatus === '4'}" @click="filterStatus = '4'">退款</span>
              <span class="tag" :class="{active: filterStatus === '5'}" @click="filterStatus = '5'">完成</span>
              <span class="tag" :class="{active: filterStatus === '6'}" @click="filterStatus = '6'">结算中</span>
              <span class="tag" :class="{active: filterStatus === '7'}" @click="filterStatus = '7'">手动结算</span>
            </div>
          </section>

        </div>
        <div class="drawer-footer">
          <div class="btn-reset" @click="resetFilter">重置</div>
          <div class="btn-confirm" @click="confirmFilter">确定</div>
        </div>
      </div>
    </div>

    <el-dialog title="选择场站" :visible.sync="showStationPopup" width="100%" custom-class="bottom-dialog">
      <div class="station-content">
        <div class="station-item" :class="{active: currentStationId === null}" @click="selectStation(null, '全部场站')">
          <span>全部场站</span>
          <i class="el-icon-success" v-if="currentStationId === null"></i>
        </div>
        <div class="station-item" :class="{active: currentStationId === item.id}" v-for="item in stationList" :key="item.id" @click="selectStation(item.id, item.plotName)">
          <span>{{ item.plotName }}</span>
          <i class="el-icon-success" v-if="currentStationId === item.id"></i>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getOrderList, agentPlotList } from "@/api/newApi";

export default {
  name: 'OrderManage',
  data() {
    return {
      showSearch: false,
      showStationPopup: false,
      showFilterDrawer: false,
      showTimeFilter: false,
      showSourceFilter: false,
      showStatusFilter: false,
      currentStationId: null,
      currentStationName: '全部场站',
      stationList: [],
      orderList: [],
      totalCount: 0,
      loading: false,
      filterTime: 'threeMonth',
      filterSource: '',
      filterStatus: '',
      timeFilterLabel: '近三月',
      sourceFilterLabel: '订单来源',
      statusFilterLabel: '订单状态',
      startDate: '',
      endDate: '',
      orderStateMap: {
        '1': { text: '下单', class: 'blue' },
        '2': { text: '取消', class: 'gray' },
        '3': { text: '支付成功', class: 'green' },
        '4': { text: '退款', class: 'orange' },
        '5': { text: '完成', class: 'green' },
        '6': { text: '结算中', class: 'blue' },
        '7': { text: '手动结算', class: 'gray' }
      }
    };
  },
  computed: {
    timeFilterLabelMap() {
      return {
        'today': '今日',
        'yesterday': '昨日',
        'month': '近一月',
        'threeMonth': '近三月'
      };
    }
  },
  mounted() {
    this.getStationList();
    this.getOrderList();
    this.updateDateRange();
  },
  methods: {
    async getStationList() {
      try {
        const res = await agentPlotList({});
        if (res.data && res.data.length > 0) {
          this.stationList = res.data;
        }
      } catch (err) {
        console.log('获取场站列表失败', err);
      }
    },
    async getOrderList() {
      this.loading = true;
      try {
        const now = new Date();
        let startTime = '';
        let endTime = this.formatDate(now) + ' 23:59:59';

        if (this.filterTime === 'today') {
          startTime = this.formatDate(now) + ' 00:00:00';
        } else if (this.filterTime === 'yesterday') {
          const yesterday = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 1);
          startTime = this.formatDate(yesterday) + ' 00:00:00';
          endTime = this.formatDate(yesterday) + ' 23:59:59';
        } else if (this.filterTime === 'month') {
          const monthAgo = new Date(now.getFullYear(), now.getMonth() - 1, now.getDate());
          startTime = this.formatDate(monthAgo) + ' 00:00:00';
        } else if (this.filterTime === 'threeMonth') {
          const threeMonthAgo = new Date(now.getFullYear(), now.getMonth() - 3, now.getDate());
          startTime = this.formatDate(threeMonthAgo) + ' 00:00:00';
        }

        const params = {
          pageNo: 1,
          pageSize: 50,
          orderState: this.filterStatus || undefined,
          startTime: startTime || undefined,
          endTime: endTime || undefined,
          orderSource: this.filterSource || undefined,
          plotId: this.currentStationId || undefined
        };
        const res = await getOrderList(params);
        if (res.data && res.data.records) {
          this.orderList = res.data.records;
          this.totalCount = res.data.total || res.data.records.length;
        } else if (res.data && Array.isArray(res.data)) {
          this.orderList = res.data;
          this.totalCount = res.data.length;
        } else {
          this.orderList = [];
          this.totalCount = 0;
        }
      } catch (err) {
        console.log('获取订单列表失败', err);
        this.orderList = [];
      } finally {
        this.loading = false;
      }
    },
    selectStation(id, name) {
      this.currentStationId = id;
      this.currentStationName = name;
      this.showStationPopup = false;
      this.getOrderList();
    },
    confirmFilter() {
      this.timeFilterLabel = this.timeFilterLabelMap[this.filterTime] || '近三月';
      this.showFilterDrawer = false;
      this.getOrderList();
    },
    getSourceLabel(source) {
      if (!source) return '-';
      const map = {
        '1': '微信小程序', '2': 'H5', '3': '卡', '4': '互联互通',
        1: '微信小程序', 2: 'H5', 3: '卡', 4: '互联互通'
      };
      return map[source] || source;
    },
    getStatusLabel(status) {
      if (!status && status !== 0) return '-';
      const map = {
        '1': '下单', '2': '取消', '3': '支付成功', '4': '退款', '5': '完成', '6': '结算中', '7': '手动结算',
        1: '下单', 2: '取消', 3: '支付成功', 4: '退款', 5: '完成', 6: '结算中', 7: '手动结算'
      };
      return map[status] || status;
    },
    resetFilter() {
      this.filterTime = 'threeMonth';
      this.filterSource = '';
      this.filterStatus = '';
      this.updateDateRange();
    },
    updateDateRange() {
      const now = new Date();
      let start = new Date();
      if (this.filterTime === 'today') {
        start = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      } else if (this.filterTime === 'yesterday') {
        start = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 1);
      } else if (this.filterTime === 'month') {
        start = new Date(now.getFullYear(), now.getMonth() - 1, now.getDate());
      } else if (this.filterTime === 'threeMonth') {
        start = new Date(now.getFullYear(), now.getMonth() - 3, now.getDate());
      }
      this.startDate = this.formatDate(start);
      this.endDate = this.formatDate(now);
    },
    formatDate(date) {
      const y = date.getFullYear();
      const m = String(date.getMonth() + 1).padStart(2, '0');
      const d = String(date.getDate()).padStart(2, '0');
      return `${y}-${m}-${d}`;
    },
    goDetail(item) {
      this.$router.push({ path: '/admin/orderDetail', query: { id: item.id, orderNumber: item.ordernumber || item.id } });
    },
    getStatusText(state) {
      const key = String(state);
      const s = this.orderStateMap[key];
      if (s) return s.text;
      const numKey = parseInt(state);
      const numS = this.orderStateMap[numKey];
      return numS ? numS.text : '未知(' + state + ')';
    },
    getStatusClass(state) {
      const stateClassMap = {
        1: 'blue', 2: 'gray', 3: 'green', 4: 'orange', 5: 'green', 6: 'blue', 7: 'gray',
        '1': 'blue', '2': 'gray', '3': 'green', '4': 'orange', '5': 'green', '6': 'blue', '7': 'gray'
      };
      return stateClassMap[state] || 'gray';
    }
  },
  watch: {
    filterTime() {
      this.updateDateRange();
    }
  }
};
</script>

<style lang="scss" scoped>
.order-manage-page {
  background-color: #F6F8FA;
  min-height: 100vh;
  padding-bottom: 20px;
}

.station-bar {
  background: #FFF;
  padding: 10px 16px;
  cursor: pointer;
  .station-info {
    background: #F8F9FB;
    padding: 12px;
    border-radius: 8px;
    display: flex;
    justify-content: space-between;
    font-size: 15px;
    .rotate-90 { transform: rotate(90deg); color: #999; }
  }
}

.quick-filter {
  background: #FFF;
  display: flex;
  padding: 10px 16px;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #F0F0F0;
  .dropdown-item {
    font-size: 13px;
    color: #333;
    background: #F2F4F7;
    padding: 6px 12px;
    border-radius: 15px;
    cursor: pointer;
    i { font-size: 10px; color: #BBB; }
  }
  .filter-btn {
    font-size: 13px;
    color: #666;
    display: flex;
    align-items: center;
    cursor: pointer;
    i { margin-right: 4px; }
  }
}

.summary-bar {
  padding: 15px 16px;
  display: flex;
  justify-content: space-between;
  background: #FFF;
  margin-bottom: 10px;
  font-size: 15px;
  .count { font-weight: bold; font-size: 22px; }
}

.order-list {
  padding: 0 16px;
  min-height: 300px;
  .order-card {
    background: #FFF;
    border-radius: 12px;
    margin-bottom: 12px;
    padding: 15px;
    cursor: pointer;
    .card-header {
      display: flex;
      justify-content: space-between;
      border-bottom: 1px solid #F8F8F8;
      padding-bottom: 12px;
      margin-bottom: 12px;
      .time { font-size: 14px; font-weight: bold; }
      i { color: #CCC; }
    }
    .info-row {
      display: flex;
      justify-content: space-between;
      margin-bottom: 10px;
      font-size: 14px;
      .label { color: #999; }
      .status-tag {
        padding: 2px 6px;
        border-radius: 4px;
        font-size: 12px;
        &.green { color: #52C41A; background: #E8F9ED; }
        &.blue { color: #1890FF; background: #E6F7FF; }
        &.orange { color: #FF9500; background: #FFF7E6; }
        &.gray { color: #999; background: #F5F5F5; }
      }
      .val { color: #333; &.bold { font-weight: bold; } }
    }
  }
  .empty-holder {
    text-align: center;
    padding: 60px 0;
    color: #999;
    i { font-size: 60px; margin-bottom: 15px; }
    p { font-size: 14px; }
  }
}

.filter-mask {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0,0,0,0.5);
  z-index: 2000;
  display: flex;
  justify-content: flex-end;
}

.filter-drawer {
  background: #FFF;
  width: 85%;
  height: 100%;
  border-radius: 16px 0 0 16px;
  display: flex;
  flex-direction: column;
  animation: slideIn 0.3s ease-out;
  .drawer-header {
    padding: 20px;
    text-align: center;
    font-size: 18px;
    font-weight: bold;
    position: relative;
    border-bottom: 1px solid #F5F5F5;
    i { position: absolute; right: 20px; color: #999; cursor: pointer; }
  }
  .drawer-body {
    flex: 1;
    overflow-y: auto;
    padding: 20px;
    .filter-section {
      margin-bottom: 25px;
      .section-title { font-weight: bold; margin-bottom: 12px; font-size: 15px; }
      .tag-grid {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 10px;
        .tag {
          background: #F5F7FA;
          padding: 8px 0;
          text-align: center;
          border-radius: 6px;
          font-size: 13px;
          color: #333;
          border: 1px solid transparent;
          cursor: pointer;
          &.active { background: #E6F9F7; border-color: #00BFA5; color: #00BFA5; }
        }
      }
    }
  }
  .drawer-footer {
    padding: 15px 20px;
    display: flex;
    gap: 12px;
    border-top: 1px solid #F5F5F5;
    .btn-reset {
      flex: 1;
      height: 44px;
      line-height: 44px;
      text-align: center;
      background: #FFF;
      border: 1px solid #E0E0E0;
      border-radius: 22px;
      color: #666;
      cursor: pointer;
    }
    .btn-confirm {
      flex: 1.5;
      height: 44px;
      line-height: 44px;
      text-align: center;
      background: #00BFA5;
      color: #FFF;
      border-radius: 22px;
      font-weight: bold;
      cursor: pointer;
    }
  }
}

.bottom-dialog {
  margin: 0 !important;
  position: fixed !important;
  bottom: 0;
  border-radius: 16px 16px 0 0 !important;
  .el-dialog__header { display: none; }
  .el-dialog__body { padding: 0; }
  .station-content {
    padding: 15px;
    .station-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 15px;
      border-bottom: 1px solid #f5f5f5;
      cursor: pointer;
      span { font-size: 15px; }
      .el-icon-success { color: #00BFA5; font-size: 20px; }
    }
  }
}

@keyframes slideIn {
  from { transform: translateX(100%); }
  to { transform: translateX(0); }
}
</style>